export enum EntityKeyType {
	JOB = 'job',
	JOB_COMMENT = 'jobcomment',
	JOB_COMMENT_READY = 'jobcommentready',
	JOB_COMMENTS = 'jobcomments',
	CHANNEL = 'channel',
	JOB_COMMENT_DEFAULT = 'jobcommentdefault',
	JOB_DAILY_REPORT = 'jobdailyreport',
	JOB_CHANNEL_OFFSET = 'jobchanneloffset',
	UNIT_PERIOD_CHANNELS = 'unitperiodchannels',
	SYNC = 'sync',
	HISTORICAL_QUEUE = 'historicalqueue',
}
